import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Observable } from 'rxjs';
import { CustomerEquipment } from '../../models/customer-equipment';

@Injectable()
export class CustomerEquipmentService {
  private resourcePrefix = 'customers';
  private resourceEndpoint = 'equipment';

  constructor(private http: ApiClient) {}

  public getAll(customerId: number) {
    return this.http.get<CustomerEquipment[]>(
      `${this.resourcePrefix}/${customerId}/${this.resourceEndpoint}`
    );
  }

  public add(customerId: number, item: Partial<CustomerEquipment>) {
    return this.http.post<CustomerEquipment>(
      `${this.resourcePrefix}/${customerId}/${this.resourceEndpoint}`,
      item
    );
  }

  public update(
    customerId: number,
    id: number,
    item: Partial<CustomerEquipment>
  ) {
    return this.http.put<CustomerEquipment>(
      `${this.resourcePrefix}/${customerId}/this.resourceEndpoint}/${id}`,
      item
    );
  }

  delete(customerId: number, id: number): Observable<any> {
    return this.http.delete(
      `${this.resourcePrefix}/${customerId}/${this.resourceEndpoint}/${id}`
    );
  }
}
